import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4 bg-[#000000]" data-id="element-169">
      <div className="max-w-xl mx-auto text-center" data-id="element-170">
        <div className="animate-fadeInUp" data-id="element-171">
          {/* Small badge */}
          <div className="inline-block text-brand-yellow px-6 py-2 rounded-full mb-6 border border-brand-yellow/40 tracking-wide bg-[#2D2000] shadow-lg shadow-black/50 text-[11px] font-[500]" data-id="element-172">
            💔 SISTEMA COMPLETO PARA SANAR LA RELACIÓN CON TUS PADRES DESDE HOY
          </div>

          {/* Main headline - larger and bolder */}
          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-[1.1] tracking-tight" data-id="element-173">
            👉 Empezá a sentir paz…{' '}
            <span className="text-brand-yellow" data-id="element-174">sin terapia</span>
          </h1>

          {/* Product image - optimized for LCP */}
          <div className="relative mb-6 max-w-lg mx-auto" data-id="element-175">
            <img src="https://cdn.magicpatterns.com/uploads/1Ehd2MNfm9UL8KUfchUZH7/MOCKUP_600x.png" alt="Megapack Inicial Sin Estrés" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] hover:scale-[1.02] transition-transform duration-500" data-id="element-176" />
          </div>

          {/* Yellow highlight text */}
          <p className="md:text-lg font-medium italic mb-3 max-w-sm mx-auto text-[14px] text-[#FFCE73]" data-id="element-177">
            Listo para aplicar. Sin remover todo el pasado. Sin conversaciones
            que terminan mal. Sin depender de que el otro cambie…
          </p>

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO EMPEZAR A SANAR HOY" className="w-auto mx-auto mb-5 py-3 px-6 text-sm md:text-base font-black rounded-xl" data-id="element-178" />

          {/* Trust badges - compact row */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-slate-400" data-id="element-179">
            <div className="flex items-center gap-1" data-id="element-180">
              <ShieldCheck size={14} className="text-brand-yellow bg-[#00000000]" data-id="element-181" />
              <span data-id="element-182">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-183">
              <Lock size={14} className="text-brand-yellow" data-id="element-184" />
              <span data-id="element-185">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-186">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-187" />
              <span data-id="element-188">Pagas en la moneda de tu país</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}